module.exports = __webpack_public_path__ + "static/media/satin.926142c6.jpg";